import * as SwitchPrimitive from '@radix-ui/react-switch';
import classNames from 'classnames';

import './switch.scss';

import type { SwitchProps } from './types';

export const Switch = ({ label, id, checked, onCheckedChange, disabled, className }: SwitchProps) => (
  <div className={classNames('payflow-ui switch', className)}>
    {label && (
      <label className="switch__label" htmlFor={id}>
        {label}
      </label>
    )}
    <SwitchPrimitive.Root
      className="switch__root"
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
    >
      <SwitchPrimitive.Thumb className="switch__thumb" />
    </SwitchPrimitive.Root>
  </div>
);
